module.exports = __webpack_public_path__ + "static/media/3dcamera_green.90ba4aab.png";